module.exports = __webpack_public_path__ + "img/partner7.067d8e61.png";